// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '@core/models/environment.model';
import appPackage from '../../package.json';

export const environment: Environment = {
  administration: 'https://fleetadministration.myscania.devtest.aws.scania.com/administration',
  adobeAnalyticsSourceURL: 'https://assets.adobedtm.com/03cc06ac496b/0dd6dbf5a1e1/launch-e01136a4d8e0-staging.min.js',
  auth: 'https://auth.testapicw.cs.scania.com/api/',
  datadog: {
    appId: '556a06ca-1db7-4d7a-a496-7202beb9c97e',
    appName: 'service-planning',
    clientToken: 'pub9f67151f3ca67e413ec195a61121b785'
  },
  facadeBaseAws: 'https://adminfacade.myscania.devtest.aws.scania.com',
  fleetPositionURL: 'https://fmp-fleetposition.test.cs.scania.com',
  graphqlCheckListURL: 'https://check-before-drive.service-planning.devtest.aws.scania.com/graphql',
  hereMapsApiKey: 'w80vUka5vOxeGmLl8ppK6IZ2UmmeUeGC7NAxPwyg6AQ',
  imageUploadURLPrefix: 'https://check-before-drive.service-planning.devtest.aws.scania.com/images',
  imageApi: 'https://images.fleetadministration.myscania.devtest.aws.scania.com/api',
  keycloak: {
    issuer: 'https://mylogin.ciam.preprod.aws.scania.com/auth',
    realm: 'fg-ext',
    clientId: 'cs_fmp_service_planning_app'
  },
  launchdarklyClientId: '668bd40cfecbdd10119b473c',
  mopinionDeploymentId: '9j25xdTTtSrdg4drNCSZJVxkWwpkipBpPzAOsAMj',
  myScaniaURL: 'https://myscania.devtest.aws.scania.com',
  name: 'test',
  oneTrustScript: '9d78e14a-5af5-4fc7-8d13-be82ad0bce2f-test',
  production: false,
  serviceBaseServicePlanning: 'https://frontend-gateway.service-planning.devtest.aws.scania.com',
  mediaBaseUrl: 'https://media.service-planning.devtest.aws.scania.com',
  version: appPackage.version,
  xClientName: 'fmp-serviceplanning-app'
};
